import { editorSlice } from 'app/stores/editor';
import { startup } from '../startup';
import { hideBusy } from './busy';
import { closeProject } from './close';
import { applyImageCrop, resetAppController, showImageBackground, showImageCropper, } from './crop';
import { dismissNews, loadNews } from './news';
import { editText, patchText } from './text';
import { clearTool, setActiveTool } from './tools';
export const EditorActions = Object.assign(Object.assign({}, editorSlice.actions), { hideBusy,
    loadNews,
    dismissNews,
    showImageCropper,
    showImageBackground,
    applyImageCrop,
    resetAppController,
    startup,
    closeProject,
    editText,
    patchText,
    setActiveTool,
    clearTool });
